export default __webpack_public_path__ + "media/images/testimonials/testimonial-dog-hands-654b08043bfb8bfdaabac607fc8e453d.svg";